<headline-with-icon-and-info-box
  [icon]="'error'"
  [headline]="'APPOI.PAGE_ERROR.HEADLINE' | translate"
  [infoBoxHeadline]="'APPOI.PAGE_ERROR.SUBHEADLINE' | translate"
  [infoBoxText]="'APPOI.PAGE_ERROR.DESCRIPTION' | translate"
>
</headline-with-icon-and-info-box>
